import getUrlForEnv from "./getUrlForEnv";
import env from "../env";
var services = {
    deals: [
        { reference: "deals", path: "/v1/deals" },
        { reference: "redemptions", path: "/v1/redemptions" },
        { reference: "tags", path: "/v1/tags" },
        { reference: "categories", path: "/v1/categories" },
        { reference: "favourites", path: "/v1/deals/favourites" },
        { reference: "dealLocales", path: "/v1/locales" },
        { reference: "settings", path: "/v1/settings" }
    ],
    products: [{ reference: "products", path: "/v1/products" }, { reference: "orders", path: "/v1/orders" }],
    images: [{ reference: "images", path: "/v1/images" }],
    stock: [{ reference: "stock", path: "/v1/items" }],
    pdfs: [{ reference: "pdfTemplates", path: "/v1/templates" }],
    "rewards-catalogue": [{ reference: "rewards", path: "/v1/rewards" }, { reference: "reference", path: "/v1/reference" }],
    "self-signup": [{ reference: "selfsignup", path: "/v1/signup" }],
    notifications: [
        { reference: "notificationsPushDevice", path: "/v1/push/devices" },
        { reference: "userNotificationsPushDevice", path: "/v1/push/users" }
    ]
};
var endpoints = {
    update: update,
    setEnv: update,
    getEnv: function () { return env.ENVIRONMENT_NAME; }
};
export default endpoints;
function update() {
    Object.keys(services).forEach(function (service) {
        services[service].forEach(function (item) {
            endpoints[item.reference] = getUrlForEnv(service, item.path);
        });
    });
}
